import { render, staticRenderFns } from "./PostSidebar.vue?vue&type=template&id=ee525a76&"
import script from "./PostSidebar.vue?vue&type=script&lang=js&"
export * from "./PostSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports